import React from 'react'; //eslint-disable-line no-unused-vars
import { Route, Switch, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';

export const PRIZE_V2_ROUTER = `${window.appContext}/v2/prizes`;
export const INTERVIEW_V2_ROUTER = `${window.appContext}/v2/interview`;
export const GATED_V2_ROUTER = `${window.appContext}/v2/gated`;
export const PAYOUT_V2_ROUTER = `${window.appContext}/v2/payout`;
export const PRIZE_DETAIL_V2_ROUTER = `${window.appContext}/v2/prize-detail`;
export const ERROR_V2_ROUTER = `${window.appContext}/v2/unexpected-error`;
export const ERROR_NOT_FOUND_V2_ROUTER = `${window.appContext}/v2/error-404`;
export const PARENTAL_GATE_V2_ROUTER = `${window.appContext}/v2/parental-gate`;

import { ContentGate } from '../components/access/ContentGate';
import { GAME_TITLE } from '../constants/GameTitle';
import { CompetitiveView } from '../components/competitive/CompetitiveView';
import { Interview } from '../components/interview/Interview';
import { PayoutView } from '../components/payout/PayoutView';
import { PayoutMaintenance } from '../components/payout/PayoutMaintenance';
import { PrizeDetail } from '../components/prizes/PrizeDetail';
import { ErrorView } from '../components/error/ErrorView';
import { ParentalGateView } from '../components/error/ParentalGateView';
import { selectConfigState } from '../selectors/config.selector';

export const CompetitiveRouter = () => {
    const configState = useSelector(selectConfigState);

    if (configState?.payoutMaintenance) {
        return <PayoutMaintenance />;
    }

    return (
        <Switch>
            <Route path={PRIZE_V2_ROUTER}>
                <ContentGate gameId={GAME_TITLE.FORTNITE}>
                    <CompetitiveView />
                </ContentGate>
            </Route>
            <Route path={INTERVIEW_V2_ROUTER}>
                <Interview />
            </Route>
            <Route path={PAYOUT_V2_ROUTER}>
                <ContentGate gameId={GAME_TITLE.FORTNITE}>
                    <PayoutView />
                </ContentGate>
            </Route>
            <Route path={PRIZE_DETAIL_V2_ROUTER}>
                <PrizeDetail />
            </Route>
            <Route path={ERROR_V2_ROUTER}>
                <ErrorView status={500} />
            </Route>
            <Route path={PARENTAL_GATE_V2_ROUTER}>
                <ParentalGateView />
            </Route>
            <Route path={ERROR_NOT_FOUND_V2_ROUTER}>
                <ErrorView status={404} />
            </Route>
            <Route path={'*'}>
                <Redirect to={ERROR_NOT_FOUND_V2_ROUTER} />
            </Route>
        </Switch>
    );
};

export default CompetitiveRouter;
